define('helperComponent-parseContent',[],function() {
    'use strict';

    var parseContent = function(content) {
        var res = {};

        if (!content) {
            return null;
        }

        if (!Array.isArray(content)) {
            return (typeof content === 'object' && Object.keys(content).length) ? content : null;
        }

        for (var i = 0; i < content.length; i++) {
            if (content[i] && content[i].hasOwnProperty('key') && content[i].hasOwnProperty('value')) {
                res[content[i].key] = content[i].value;
            } else if (content[i] && typeof content[i] === 'object' && Object.keys(content[i]).length) {
                for (var prop in content[i]) {
                    res[prop] = content[i][prop];
                }
            }
        }

        return (Object.keys(res).length) ? res : null;
    };

    return parseContent;
});

